import transpose from "./transpose.js";

export default function() {
  return transpose(arguments);
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-scale/node_modules/d3-array/src/zip.js
// module id = 1723
// module chunks = 0